// biome-ignore lint/style/useImportType: this bundle compiles JSX with the classic React runtime.
import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Pieces the Vocabulary screen's process and category cards share, so the
 * two sections look the same. */

export const Badge = ({ label }: { label: string }) => (
  <span className="rounded-full border border-outline px-2 py-0.5 text-xs text-text-dim">
    {label}
  </span>
);

/** Classes of a `<summary>` that discloses part of a card. */
export const summaryClass =
  "cursor-pointer text-sm text-text-dim transition-colors hover:text-text";

/** Bordered icon button; callers add the padding (`p-1.5` in a card header,
 * `p-1` in a row). */
export const iconButtonClass =
  "rounded-md border border-outline text-text-dim transition-colors hover:text-text disabled:cursor-not-allowed disabled:opacity-40";

/** The "+" that opens an add dialog. */
export const AddButton = ({ label, onClick }: { label: string; onClick: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    title={label}
    aria-label={label}
    className={`${iconButtonClass} p-1.5`}
  >
    <Plus size={16} />
  </button>
);

/** Labelled field of an add dialog. */
export const FieldLabel = ({ label, children }: { label: string; children: React.ReactNode }) => (
  // biome-ignore lint/a11y/noLabelWithoutControl: the control is passed in as `children`.
  <label className="block space-y-1">
    <span className="text-xs font-medium uppercase text-text-dim">{label}</span>
    {children}
  </label>
);

export const fieldClass =
  "w-full rounded-xl border border-outline bg-background px-3 py-2 text-text outline-none transition focus:border-primary";

/** Cancel and submit of an add dialog's form. */
export const ModalButtons = ({
  submitLabel,
  disabled,
  submitDisabled,
}: {
  submitLabel: string;
  disabled: boolean;
  submitDisabled: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-end gap-2 pt-1">
      <Dialog.Close asChild>
        <button
          type="button"
          disabled={disabled}
          className="rounded-xl border border-outline px-4 py-2 text-sm text-text-dim transition-colors hover:text-text"
        >
          {t("cancel")}
        </button>
      </Dialog.Close>
      <button
        type="submit"
        disabled={disabled || submitDisabled}
        className="rounded-xl bg-primary px-4 py-2 text-sm font-medium text-white transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {submitLabel}
      </button>
    </div>
  );
};
